.c6{z-index:2;}